import React from 'react';
import { Container, Card, Spinner, Alert, Button } from 'react-bootstrap';
const CreatingAccountPage = () => {
  return (
    <Container className="mt-5">
      <Card className="text-center">
        <Card.Body className="py-5">
          <Spinner animation="border" variant="primary" style={{ width: '4rem', height: '4rem' }} />
          <h2 className="mt-4">Your Account is Being Created</h2>
          <Alert variant="info" className="mt-4">
            <p>Your payment has been received and your account is currently being set up.</p>
            <p>This process usually takes a few minutes. Please refresh the page or check back shortly.</p>
            <p className="mb-0">You will receive an email notification once your account is ready.</p>
          </Alert>
          <Button variant="primary" className="mt-3" onClick={() => window.location.reload()}>
            Refresh Page
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};
export default CreatingAccountPage;